// Partnership Outreach Email Generator
// Professional B2B email for establishing referral partnerships

const HOMEGO_DBS_TEAM = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/0koj4d3w_IMG_6794.PNG";
const HOMEGO_VAN_IMAGE = "https://customer-assets.emergentagent.com/job_removals-quotation/artifacts/y30jebbk_WhatsApp%20Image%202026-04-06%20at%2015.06.18.jpeg";

const generatePartnershipEmailHTML = (data) => {
  const {
    // Partner Details
    partner_name = "Partner",
    partner_company = "Your Company",
    partner_type = "Storage", // Storage, Real Estate, Estate Agent, Letting Agent, etc.
    
    // Location
    area_name = "Milton Keynes",
    
    // Company Details
    director_name = "Allah Nazar Ihsan",
    company_name = "HomeGo Removals & Packing Ltd",
    company_reg = "16811153",
    company_phone = "0330 043 4791",
    company_email = "office@homego-removals.com",
    company_website = "www.homego-removals.com",
    
    // Commission
    commission_amount = "100",
    
    // Services
    services = "House removals, office removals and Packing services",
    
    // Insurance
    insurance_amount = "£50,000",
    
    // Custom intro message
    intro_message = "I hope you are well.",
    
    // Custom closing
    closing_message = "We would love the opportunity to discuss this further and explore how we can collaborate effectively.",
    
    // Show attachments mention
    show_attachments = true,
    
    // Partnership benefits to highlight
    benefit_1 = "£100 commission for every successful booking referral",
    benefit_2 = "Priority service for your referred customers",
    benefit_3 = "Dedicated account manager for your partnership",
    benefit_4 = "Co-branded marketing materials available",
    benefit_5 = "Monthly reporting on referral performance",
  } = data;

  return `
<!DOCTYPE html>
<html lang="en">
<head>
  <meta charset="UTF-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Partnership Opportunity - HomeGo Removals</title>
  <style>
    @media screen and (max-width: 620px) {
      .mobile-full { width: 100% !important; }
      .mobile-padding { padding: 15px !important; }
      .mobile-stack { display: block !important; width: 100% !important; }
    }
  </style>
</head>
<body style="margin: 0; padding: 0; background-color: #f5f5f5; font-family: 'Segoe UI', Arial, sans-serif;">
  
  <table role="presentation" width="100%" cellspacing="0" cellpadding="0" border="0" style="background-color: #f5f5f5;">
    <tr>
      <td align="center" style="padding: 30px 15px;">
        
        <table role="presentation" width="650" cellspacing="0" cellpadding="0" border="0" style="max-width: 650px;">
          
          <!-- PREMIUM HEADER -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 16px 16px 0 0; padding: 0;">
              <!-- Gold accent bar -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="background: linear-gradient(90deg, #D4AF37 0%, #F4D03F 50%, #D4AF37 100%); height: 4px; border-radius: 16px 16px 0 0;"></td>
                </tr>
              </table>
              
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td style="padding: 30px 35px;">
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td>
                          <h1 style="margin: 0; font-size: 32px; font-weight: 800; letter-spacing: -1px;">
                            <span style="color: #D4AF37;">Home</span><span style="color: #FFFFFF;">Go</span>
                          </h1>
                          <p style="margin: 5px 0 0; font-size: 11px; color: #D4AF37; letter-spacing: 2px; text-transform: uppercase;">Removals & Packing Ltd</p>
                        </td>
                        <td align="right" style="vertical-align: middle;">
                          <table border="0" cellpadding="0" cellspacing="0">
                            <tr>
                              <td style="background: rgba(16, 185, 129, 0.15); border: 1px solid #10B981; border-radius: 8px; padding: 8px 14px;">
                                <p style="margin: 0; font-size: 10px; color: #10B981; text-transform: uppercase; letter-spacing: 1px;">✓ Registered Company</p>
                                <p style="margin: 3px 0 0; font-size: 12px; color: #10B981; font-weight: 700;">${company_reg}</p>
                              </td>
                            </tr>
                          </table>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- PARTNERSHIP OPPORTUNITY BANNER -->
          <tr>
            <td style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); padding: 25px 35px; text-align: center;">
              <p style="margin: 0 0 5px; font-size: 11px; color: #000; text-transform: uppercase; letter-spacing: 3px; opacity: 0.8;">Business Partnership Opportunity</p>
              <h2 style="margin: 0; font-size: 26px; font-weight: 800; color: #000;">
                Let's Work Together
              </h2>
            </td>
          </tr>
          
          <!-- VAN IMAGE -->
          <tr>
            <td style="background: #ffffff;">
              <img src="${HOMEGO_VAN_IMAGE}" alt="HomeGo Removals Van" style="width: 100%; height: 180px; object-fit: cover; display: block;" />
            </td>
          </tr>
          
          <!-- MAIN LETTER CONTENT -->
          <tr>
            <td style="background: #ffffff; padding: 35px 40px;">
              
              <!-- Greeting -->
              <p style="margin: 0 0 20px; font-size: 16px; color: #333; line-height: 1.6;">
                Dear <strong style="color: #1a1a1a;">${partner_name}</strong>,
              </p>
              
              <p style="margin: 0 0 20px; font-size: 15px; color: #444; line-height: 1.7;">
                ${intro_message}
              </p>
              
              <!-- Introduction -->
              <p style="margin: 0 0 20px; font-size: 15px; color: #444; line-height: 1.7;">
                My name is <strong>${director_name}</strong>, Company Director of <strong>${company_name}</strong> (${company_reg}). We provide professional <strong>${services}</strong> in the <strong>${area_name}</strong> and surrounding areas.
              </p>
              
              <!-- Partnership Proposal -->
              <p style="margin: 0 0 20px; font-size: 15px; color: #444; line-height: 1.7;">
                I am reaching out because I believe there is a great opportunity for us to work together. Many of your customers may require reliable removals and packing services when moving items into or out of ${partner_type.toLowerCase()}. We would be pleased to support your clients with a high-quality, efficient service.
              </p>
              
              <!-- Commission Highlight Box -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #10B981 0%, #059669 100%); border-radius: 12px; margin: 25px 0;">
                <tr>
                  <td style="padding: 25px; text-align: center;">
                    <p style="margin: 0 0 5px; font-size: 12px; color: rgba(255,255,255,0.9); text-transform: uppercase; letter-spacing: 2px;">Partnership Commission</p>
                    <p style="margin: 0; font-size: 48px; font-weight: 800; color: #fff;">
                      £${commission_amount}
                    </p>
                    <p style="margin: 8px 0 0; font-size: 14px; color: rgba(255,255,255,0.95);">
                      For every customer you refer who successfully books our services
                    </p>
                  </td>
                </tr>
              </table>
              
              <p style="margin: 0 0 25px; font-size: 15px; color: #444; line-height: 1.7;">
                We believe this could be a mutually beneficial arrangement and help enhance the overall experience for your customers.
              </p>
              
              <!-- Partnership Benefits -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #f8f9fa; border-radius: 12px; border-left: 4px solid #D4AF37; margin-bottom: 25px;">
                <tr>
                  <td style="padding: 20px 25px;">
                    <h3 style="margin: 0 0 15px; font-size: 16px; font-weight: 700; color: #1a1a1a;">
                      🤝 Partnership Benefits
                    </h3>
                    <table border="0" cellpadding="0" cellspacing="0" width="100%">
                      <tr>
                        <td style="padding: 6px 0; font-size: 14px; color: #444;">
                          <span style="color: #10B981; margin-right: 10px;">✓</span> ${benefit_1}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 6px 0; font-size: 14px; color: #444;">
                          <span style="color: #10B981; margin-right: 10px;">✓</span> ${benefit_2}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 6px 0; font-size: 14px; color: #444;">
                          <span style="color: #10B981; margin-right: 10px;">✓</span> ${benefit_3}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 6px 0; font-size: 14px; color: #444;">
                          <span style="color: #10B981; margin-right: 10px;">✓</span> ${benefit_4}
                        </td>
                      </tr>
                      <tr>
                        <td style="padding: 6px 0; font-size: 14px; color: #444;">
                          <span style="color: #10B981; margin-right: 10px;">✓</span> ${benefit_5}
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
              
              ${show_attachments ? `
              <!-- Attachments Notice -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: #EFF6FF; border: 1px solid #3B82F6; border-radius: 8px; margin-bottom: 25px;">
                <tr>
                  <td style="padding: 15px 20px;">
                    <p style="margin: 0; font-size: 13px; color: #1E40AF;">
                      📎 <strong>Attachments:</strong> For your reference, I have attached our insurance certificate and legal documents to this email.
                    </p>
                  </td>
                </tr>
              </table>
              ` : ''}
              
              <!-- Closing -->
              <p style="margin: 0 0 20px; font-size: 15px; color: #444; line-height: 1.7;">
                ${closing_message}
              </p>
              
              <p style="margin: 0 0 25px; font-size: 15px; color: #444; line-height: 1.7;">
                Thank you for your time, and I look forward to hearing from you.
              </p>
              
              <!-- Signature -->
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td>
                    <p style="margin: 0 0 5px; font-size: 14px; color: #666;">Kind regards,</p>
                    <p style="margin: 0 0 3px; font-size: 18px; font-weight: 700; color: #1a1a1a;">${director_name}</p>
                    <p style="margin: 0 0 3px; font-size: 13px; color: #666;">Company Director</p>
                    <p style="margin: 0; font-size: 14px; font-weight: 600; color: #D4AF37;">${company_name}</p>
                  </td>
                </tr>
              </table>
              
            </td>
          </tr>
          
          <!-- DBS APPROVED TEAM -->
          <tr>
            <td style="background: #ffffff; padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 12px; overflow: hidden;">
                <tr>
                  <td>
                    <img src="${HOMEGO_DBS_TEAM}" alt="HomeGo DBS Approved Team" style="width: 100%; height: 180px; object-fit: cover; object-position: center top; display: block;" />
                  </td>
                </tr>
                <tr>
                  <td style="padding: 15px; text-align: center;">
                    <span style="display: inline-block; background: linear-gradient(135deg, #D4AF37 0%, #F4D03F 100%); color: #000; font-size: 10px; font-weight: 700; padding: 6px 16px; border-radius: 20px; text-transform: uppercase; letter-spacing: 1px;">
                      🛡️ DBS APPROVED • TRUSTED MOVERS • VERIFIED CREW
                    </span>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- TRUST BADGES -->
          <tr>
            <td style="background: #ffffff; padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td width="33%" style="text-align: center; padding: 15px; background: #f8f9fa; border-radius: 8px 0 0 8px;">
                    <p style="margin: 0; font-size: 10px; color: #666; text-transform: uppercase;">🏛️ Registered</p>
                    <p style="margin: 5px 0 0; font-size: 14px; color: #1a1a1a; font-weight: 700;">${company_reg}</p>
                  </td>
                  <td width="34%" style="text-align: center; padding: 15px; background: #f8f9fa; border-left: 1px solid #e5e7eb; border-right: 1px solid #e5e7eb;">
                    <p style="margin: 0; font-size: 10px; color: #666; text-transform: uppercase;">🛡️ Insured</p>
                    <p style="margin: 5px 0 0; font-size: 14px; color: #1a1a1a; font-weight: 700;">${insurance_amount}</p>
                  </td>
                  <td width="33%" style="text-align: center; padding: 15px; background: #f8f9fa; border-radius: 0 8px 8px 0;">
                    <p style="margin: 0; font-size: 10px; color: #666; text-transform: uppercase;">⭐ Trustpilot</p>
                    <p style="margin: 5px 0 0; font-size: 14px; color: #00B67A; font-weight: 700;">4.9/5 Rating</p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
          <!-- CONTACT CTA -->
          <tr>
            <td style="background: #ffffff; padding: 0 40px 30px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%" style="background: linear-gradient(135deg, #D4AF37 0%, #B8860B 100%); border-radius: 12px;">
                <tr>
                  <td style="padding: 25px; text-align: center;">
                    <p style="margin: 0 0 15px; font-size: 16px; font-weight: 700; color: #000;">Ready to discuss this partnership?</p>
                    <table border="0" cellpadding="0" cellspacing="10" style="margin: 0 auto;">
                      <tr>
                        <td>
                          <a href="tel:${company_phone.replace(/\s/g, '')}" style="display: inline-block; background: #000; color: #D4AF37; font-size: 14px; font-weight: 600; text-decoration: none; padding: 12px 25px; border-radius: 25px;">
                            📞 ${company_phone}
                          </a>
                        </td>
                        <td>
                          <a href="mailto:${company_email}" style="display: inline-block; background: #000; color: #D4AF37; font-size: 14px; font-weight: 600; text-decoration: none; padding: 12px 25px; border-radius: 25px;">
                            ✉️ Email Us
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>


          
          <!-- FOOTER -->
          <tr>
            <td style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%); border-radius: 0 0 16px 16px; padding: 25px 35px;">
              <table border="0" cellpadding="0" cellspacing="0" width="100%">
                <tr>
                  <td align="center">
                    <p style="margin: 0 0 8px; font-size: 16px; font-weight: 700;">
                      <span style="color: #D4AF37;">Home</span><span style="color: #fff;">Go</span>
                      <span style="color: #888; font-weight: 400;"> Removals & Packing Ltd</span>
                    </p>
                    <p style="margin: 0 0 10px; font-size: 11px; color: #888;">
                      Professional Removals & Packing Services
                    </p>
                    <p style="margin: 0; font-size: 12px; color: #D4AF37;">
                      📞 ${company_phone} | 📧 ${company_email} | 🌐 ${company_website}
                    </p>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
          
        </table>
      </td>
    </tr>
  </table>
  
</body>
</html>
`;
};

export default generatePartnershipEmailHTML;
